import { IconUploadArrow } from '@fabric-app/icons/old';
import { IconResourceSpace, IconFolderCreate, IconNavigational24Audio, IconNavigational24Note, IconNavigational24Camera, IconNavigational24Upload, IconNavigational24Link } from '@fabric-app/icons/svg';
import { SubscriptionTier } from '@fabric/woody-client';

var NewResourceType = /* @__PURE__ */ function(NewResourceType2) {
  NewResourceType2["Link"] = "page";
  NewResourceType2["Note"] = "notepad";
  NewResourceType2["Upload"] = "stored_file";
  NewResourceType2["Screenshot"] = "screenshot";
  NewResourceType2["VoiceNote"] = "voice_note";
  NewResourceType2["Photo"] = "photo";
  NewResourceType2["Folder"] = "folder";
  NewResourceType2["Space"] = "space";
  return NewResourceType2;
}({});
const NewResourceTypesConfig = {
  ["page"]: {
    icon: IconNavigational24Link,
    label: "Add new link",
    minLabel: "Link",
    value: "page",
    testId: "link-option",
    kbd: "L",
    order: {
      mobile: 3,
      desktop: 1,
      footer: 0
    }
  },
  ["stored_file"]: {
    icon: IconNavigational24Upload,
    label: "Add new upload",
    minLabel: "Upload",
    value: "stored_file",
    testId: "upload-option",
    kbd: "U",
    order: {
      mobile: 4,
      desktop: 2,
      footer: 1
    }
  },
  ["photo"]: {
    icon: IconNavigational24Camera,
    label: "Photo",
    minLabel: "Photo",
    value: "photo",
    testId: "photo-option",
    kbd: "C",
    hidden: {
      mobileOnly: true,
      footer: true
    },
    order: {
      mobile: 2,
      desktop: 0,
      footer: 2
    }
  },
  ["notepad"]: {
    icon: IconNavigational24Note,
    label: "Note",
    minLabel: "Note",
    value: "notepad",
    testId: "note-option",
    kbd: "N",
    order: {
      mobile: 5,
      desktop: 3,
      footer: 3
    }
  },
  ["voice_note"]: {
    tier: SubscriptionTier.STARTER,
    icon: IconNavigational24Audio,
    label: "Voice note",
    minLabel: "Voice note",
    value: "voice_note",
    testId: "voice-note-option",
    kbd: "V",
    order: {
      mobile: 1,
      desktop: 4,
      footer: 4
    },
    hidden: {
      minimumVersion: {
        ios: "0.4.4-build.1",
        android: "0.1.23-build.38"
      }
    }
  },
  ["folder"]: {
    icon: IconFolderCreate,
    label: "Folder",
    minLabel: "Folder",
    value: "folder",
    testId: "folder-option",
    iconStyle: {
      marginTop: -4,
      width: "1.125rem",
      height: "auto"
    },
    hidden: {
      footer: true
    },
    prominent: true,
    requirements: {
      insideFolder: true
    },
    order: {
      mobile: 0,
      desktop: 5,
      footer: 5
    }
  },
  ["space"]: {
    icon: IconResourceSpace,
    label: "Space",
    minLabel: "Space",
    value: "space",
    testId: "space-option",
    iconStyle: {
      width: "1.125rem",
      height: "auto"
    },
    hidden: {
      footer: true
    },
    prominent: true,
    requirements: {
      insideFolder: false
    },
    order: {
      mobile: 0,
      desktop: 5,
      footer: 5
    }
  },
  ["screenshot"]: {
    icon: IconUploadArrow,
    label: "Add new screenshot",
    minLabel: "Screenshot",
    value: "screenshot",
    testId: "screenshot-option",
    hidden: {
      always: true
    },
    order: {
      mobile: -1,
      desktop: -1,
      footer: -1
    }
  }
};
const NewResourceTypesOptions = Object.values(NewResourceTypesConfig).sort((a) => a.prominent ? -1 : 1).filter((option) => !option.hidden?.always);
const NewResourceTypesFooterOptions = NewResourceTypesOptions.filter((option) => !option.hidden?.footer && !option.hidden?.always).sort((a, b) => a.order.footer - b.order.footer);

export { NewResourceType, NewResourceTypesConfig, NewResourceTypesFooterOptions, NewResourceTypesOptions };
//# sourceMappingURL=config.js.map
